<template>
  <div>
    <v-card
      v-if="interactable"
      outlined
      :style="cardStyle"
      :hover="hover"
      @mouseover="hover = true"
      @mouseleave="hover = false"
      @click="reveal"
      :disabled="!enabled"
    >
      <v-card-text
        class="text-center text-uppercase my-3"
        :style="{ color: textColor }"
      >
        {{ cell.word }}
      </v-card-text>
    </v-card>
    <v-card v-else outlined :style="cardStyle">
      <v-card-text
        class="text-center text-uppercase my-3"
        :style="{ color: textColor }"
      >
        {{ cell.word }}
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import colors from '../utils/colors';
import textColor from '../utils/textColor';

export default {
  name: 'BoardCard',
  props: {
    enabled: {
      type: Boolean,
      required: true,
    },
    cell: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  computed: {
    color() {
      switch (this.cell.type) {
        case 'A':
          return colors.teamA;

        case 'B':
          return colors.teamB;

        case 'neutral':
          return '#b0a89e';

        case 'black':
          return '#323232';

        default:
          return '#FFFFFF';
      }
    },
    textColor() {
      if (this.cell.revealed) {
        return textColor(this.color);
      }

      if (this.cell.type !== null) {
        return this.color;
      }

      return '#000000';
    },
    interactable() {
      return this.enabled && this.cell.type === null && !this.cell.revealed;
    },
    cardStyle() {
      if (this.cell.revealed) {
        return {
          background: this.color,
        };
      }

      if (this.cell.type !== null) {
        return {
          'border-color': this.color,
          'border-width': '2px',
          margin: '-1px',
        };
      }

      return {};
    },
  },
  methods: {
    reveal() {
      if (!this.enabled) {
        return;
      }

      this.$emit('reveal', this.cell);
    },
  },
};
</script>

<style scoped></style>
